import objectAssign from 'object-assign';
import events from 'events';
import AppDispatcher from './../dispatcher/AppDispatcher';
import AppConstants from './../constants/AppConstants';

const CHANGE_EVENT = 'change';
let UIColor = 'dark';
let scrolledPastTitle = false;


const MediaLabStoryStore = objectAssign({}, events.EventEmitter.prototype, {
  /**
   * Gets whether the preloader is showing
   * @returns {String} Whether to show the preloader
   */
  getState() {
    return {
      UIColor,
      scrolledPastTitle,
    };
  },


  /**
   * Emits change event
   * @returns {undefined} undefined
   */
  emitChange() {
    this.emit(CHANGE_EVENT);
  },


  /**
   * Ads a listener function to the store
   * @param {Function} callback A function to add as a callback
   * @returns {undefined} undefined
   */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },


  /**
   * Removes a listener function from the store
   * @param {Function} callback A function to remove from the callbacks
   * @returns {undefined} undefined
   */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },


  /**
   * Listens for events and takes action accordingly
   * @returns {Boolean} true
   */
  dispatcherIndex: AppDispatcher.register((payload) => {
    const action = payload.action;

    switch (action.actionType) {
      case AppConstants.UI_COLOR_CHANGE:
        UIColor = action.uiColor;

        MediaLabStoryStore.emitChange();

        break;

      case AppConstants.SCROLLED_PAST_TITLE:
        scrolledPastTitle = action.scrolledPastTitle;

        MediaLabStoryStore.emitChange();

        break;

      default:
        break;
    }

    return true;
  }),
});

export default MediaLabStoryStore;



/** WEBPACK FOOTER **
 ** ./assets/js/src/stores/MediaLabStoryStore.js
 **/